import { type ReactElement } from 'react';
import classnames from 'classnames/bind';
import { Typography, Input } from '@weareopenr/component-library';
import styles from '../DesignPlatformExportFlow.module.scss';

const cx = classnames.bind(styles);

interface MenuTitleStepProps {
  menuTitleMode: 'venue_name' | 'override';
  menuTitleOverride: string;
  onSelectMode: (mode: 'venue_name' | 'override') => void;
  onChangeOverride: (value: string) => void;
}

export const MenuTitleStep = ({
  menuTitleMode,
  menuTitleOverride,
  onSelectMode,
  onChangeOverride,
}: MenuTitleStepProps): ReactElement => {
  const isVenueNameSelected = menuTitleMode === 'venue_name';
  const isOverrideSelected = menuTitleMode === 'override';

  return (
    <div className={styles['step-content']}>
      <div className={styles['menu-title-options']}>
        <button
          type="button"
          className={cx('menu-title-option', { 'menu-title-option-selected': isVenueNameSelected })}
          onClick={() => onSelectMode('venue_name')}
        >
          <div className={styles['menu-title-radio']}>
            <div className={cx('radio-outer', { 'radio-outer-selected': isVenueNameSelected })}>
              {isVenueNameSelected && <div className={styles['radio-inner']} />}
            </div>
          </div>
          <div className={styles['menu-title-content']}>
            <Typography size="medium" weight="bold">
              Use Venue Name
            </Typography>
            <Typography size="xsmall" className={styles['menu-title-description']}>
              This option uses the venue name within Openr as the title on each menu generated
            </Typography>
          </div>
        </button>

        <button
          type="button"
          className={cx('menu-title-option', { 'menu-title-option-selected': isOverrideSelected })}
          onClick={() => onSelectMode('override')}
        >
          <div className={styles['menu-title-radio']}>
            <div className={cx('radio-outer', { 'radio-outer-selected': isOverrideSelected })}>
              {isOverrideSelected && <div className={styles['radio-inner']} />}
            </div>
          </div>
          <div className={styles['menu-title-content']}>
            <Typography size="medium" weight="bold">
              Override Menu Title
            </Typography>
            <Typography size="xsmall" className={styles['menu-title-description']}>
              This option allows you to define a customised menu title that will be used for all menus generated in this
              flow
            </Typography>
          </div>
        </button>

        <div className={styles['menu-title-input']}>
          <Input
            id="menu-title-override"
            type="text"
            label="Custom menu title"
            placeholder="Override Title"
            value={menuTitleOverride}
            onChange={(e) => onChangeOverride(e.target.value)}
            disabled={!isOverrideSelected}
          />
        </div>
      </div>
    </div>
  );
};
